import Vue from "vue";

export default {
    requestFilePreview(storageId) {
        return Vue.http.post(`file/${storageId}/preview`);
    }
}